import { c as a } from "./ghl-ui.es384.js";
import i from "./ghl-ui.es1158.js";
const {
  cubicBezierEaseOut: n
} = i;
function o({
  duration: t = ".2s"
} = {}) {
  return [a("&.fade-up-width-expand-transition-leave-active", {
    transition: `
 opacity ${t} ${n},
 max-width ${t} ${n},
 transform ${t} ${n}
 `
  }), a("&.fade-up-width-expand-transition-enter-active", {
    transition: `
 opacity ${t} ${n},
 max-width ${t} ${n},
 transform ${t} ${n}
 `
  }), a("&.fade-up-width-expand-transition-enter-to", {
    opacity: 1,
    transform: "translateX(0) translateY(0)"
  }), a("&.fade-up-width-expand-transition-enter-from", {
    maxWidth: "0 !important",
    opacity: 0,
    transform: "translateY(60%)"
  }), a("&.fade-up-width-expand-transition-leave-from", {
    opacity: 1,
    transform: "translateY(0)"
  }), a("&.fade-up-width-expand-transition-leave-to", {
    maxWidth: "0 !important",
    opacity: 0,
    transform: "translateY(60%)"
  })];
}
export {
  o as fadeUpWidthExpandTransition
};
